export default __webpack_public_path__ + "apollo.0840a62f.jpg";